const pino = require('pino');

const pinoOptions = {
  level: 'info'
}

const rawLogger = pino(pinoOptions);

module.exports = {
  rawLogger,
  getLogger: (name) => {
    return rawLogger.child({logger: {name}})
  }
}
